import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
	readonly DELIMITER = '-';

	fromModel(value: string | null): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	toModel(date: NgbDateStruct | null): string | null {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
	}
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable({ providedIn: 'root' })
export class CustomDateParserFormatter extends NgbDateParserFormatter {
	month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	fullmonth = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	//readonly DELIMITER = '/';
	readonly DELIMITER = ' ';

	parse(value: string): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt((this.month.indexOf(date[1]) + 1).toString(), 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	parseMonth(value: string): NgbDateStruct | null {
		if (value) {
			const date = value.split(" ");
			return {
				day: 1,
				month: parseInt((this.fullmonth.indexOf(date[0]) + 1).toString(), 10),
				year: parseInt(date[1], 10),
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
		return date ? date.day + this.DELIMITER + this.month[date.month - 1] + this.DELIMITER + date.year : '';
	}
	Newformat1(date: NgbDateStruct | null): string {
		if (date) {
		  const day = String(date.day).padStart(2, '0');   
		  return `${day}${this.month[date.month - 1]}${date.year}`;
		}
		return '';
	  }
}
